// Wave AW.3-React (2026-05-16) — 외부 바이어 API helper
// utils/api.js authFetch 는 'autodoc_token' (ERP) 사용 — 바이어는 별도 'autodex_buyer_token'

import { API } from '../../utils/api';

function getBuyerToken() {
  try { return localStorage.getItem('autodex_buyer_token') || ''; } catch (e) { return ''; }
}

// authBuyerFetch — Authorization: Bearer + JSON Content-Type 자동
function authBuyerFetch(url, options) {
  options = options || {};
  options.headers = options.headers || {};
  var token = getBuyerToken();
  if (token) options.headers['Authorization'] = 'Bearer ' + token;
  if (!options.headers['Content-Type'] && !(options.body instanceof FormData)) {
    options.headers['Content-Type'] = 'application/json';
  }
  return fetch(url, options);
}

// 응답 정규화 — 401 시 토큰 정리 + 로그인 화면 redirect (caller 에서 처리)
function isUnauthorized(res) {
  return res && res.status === 401;
}

// 401 처리 — 토큰 폐기 + 로그인 화면
function handleUnauthorized(navigate) {
  try {
    localStorage.removeItem('autodex_buyer_token');
    localStorage.removeItem('autodex_buyer_refresh');
    sessionStorage.removeItem('autodex_buyer');
  } catch (e) { /* silent */ }
  if (navigate) navigate('/buyer/login');
}

// 사진 fetch → blob URL (인증된 이미지 — <img src> 가 Authorization 못 실음 대응)
// 사용: useEffect 에서 호출, return 시 URL.revokeObjectURL 정리
function fetchAuthImageBlobUrl(relativePath) {
  return authBuyerFetch(API + relativePath, {})
    .then(function(r) {
      if (!r.ok) throw new Error('image fetch failed: ' + r.status);
      return r.blob();
    })
    .then(function(blob) { return URL.createObjectURL(blob); });
}

export { authBuyerFetch, getBuyerToken, isUnauthorized, handleUnauthorized, fetchAuthImageBlobUrl };
